import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { ComponentBase } from '../shared/base/base-component';

@Component({
  selector: 'app-callback',
  templateUrl: 'callback.component.html',
  standalone: false,
})
export class CallbackComponent extends ComponentBase implements OnInit {
  isAuthenticated: boolean = false;
  constructor(private authService: AuthService) {
    super();
  }
  ngOnInit(): void {
    this.authService.setSession();
  }

  setSession() {
    this.authService.setSession();
  }
}
